import React from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Moment from "moment";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { getOtherTask } from "../Actions/ShipViewAPI";

let userkey = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");

class StaffOtherTaskEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDateOpen: false,
            searchData: {
                shipId: 0,
                shipTaskId: 0,
                taskType: "",
                taskdescription: "",
                taskdeadLine: "",
                filesPDF: '',
                isCompleted: false,
                completedDate: ""

            },
            multifilesPDF: [],
            files: [],
            taskData: false,
            attachments: [],
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, EditTaskList } = nextProps;
        if (EditTaskList && EditTaskList !== '') {
            prevState.searchData.taskType = EditTaskList?.task;
            prevState.searchData.taskdescription = EditTaskList?.description;
            prevState.searchData.taskdeadLine = EditTaskList?.deadLine;
            prevState.searchData.shipId = EditTaskList?.shipId;
            prevState.searchData.shipTaskId = EditTaskList?.shipTaskId;
            prevState.searchData.isCompleted = EditTaskList?.isCompleted;
            prevState.searchData.completedDate = EditTaskList?.completedDate;
            prevState.searchData.filesPDF = EditTaskList && EditTaskList?.attachments?.length > 0 ? EditTaskList?.attachments?.map(items => items.attachmentName) : "";
            prevState.files =  EditTaskList?.attachments?.length > 0 ? EditTaskList?.attachments?.map(u => {
                let attachments = {
                    attachmentId: u.attachmentId,
                    attachmentName: u.attachmentName,
                    attachmentGuid: u.attachmentGuid,
                    isDeleted: false,
                };
                return attachments;
            }):[];
            dispatch({ type: "EditOtherTask", data: '' });
        }
    }

    handleInputChange = (e) => {
        let nodeName = e.target.name;
        this.state.searchData[nodeName] = e.target.value;
        this.setState({});
    }

    handleDeadlineDateChange = (date) => {
        this.state.searchData.taskdeadLine = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            fromDateOpen: false,
        });
    }

    openDeadlineDatePicker = () => {
        this.setState({
            fromDateOpen: !this.state.fromDateOpen
        });
    }

    handleBlur() {
        this.setState({
            fromDateOpen: false,
        });
      }

    fileSelectedHandlers = (e) => {
        this.state.taskData = true
        this.state.multifilesPDF = [...e.target.files]
        let file = "";
        let multifile = [...e.target.files]
        multifile.map((i, index) => {
            if (index === 0) {
                file = i.name
            }
            else {
                file = file + ', ' + i.name
            }
        })
        this.state.searchData.filesPDF = file;
        this.setState({});
    }

    ClearInputsPDF = () => {
        if (this.state.files) {
            this.state.files = this.state.files && this.state.files.map(u => {
                let attachments = {
                    attachmentId: u.attachmentId,
                    attachmentName: u.attachmentName,
                    attachmentGuid: u.attachmentGuid,
                    isDeleted: true,
                };
                return attachments;
            });
        }
        this.state.searchData.filesPDF = "";
        this.setState({ multifilesPDF: '', attachments: [] });
    }

    SubmitOtherTask = () => {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { shipId } = params;
        if (this.state.searchData.taskType === '') {
            swal('Error!', 'Please enter a task', 'warning');
        }
        else {
            if (this.state.taskData) {
                const data = new FormData()
                for (const postItem of this.state.multifilesPDF) {
                    data.append('file', postItem)
                }
                let url1 = `${API.AttachmentsAPI}`;
                axios.post(url1, data)
                    .then((response) => {
                        if (response.data) {
                            let attachment = response.data.map((i) => ({
                                isDeleted: false,
                                attachmentId: 0,
                                attachmentName: i.FileName,
                                attachmentGuid: i.Guid
                            }))
                            this.state.attachments = attachment;
                            let url = `${API.PutOtherTask}`;
                            let datas = {
                                shipTaskId: this.state.searchData.shipTaskId,
                                shipId: this.state.searchData.shipId,
                                task: this.state.searchData.taskType,
                                description: this.state.searchData.taskdescription,
                                deadLine: this.state.searchData.taskdeadLine,
                                completedDate: this.state.searchData.completedDate,
                                isCompleted: false,
                                isDeleted: false,
                                attachments: this.state.attachments,
                                modifiedBy: userkey.email
                            }
                            axios.put(url, datas)
                                .then((res) => {
                                    if (res.data) {
                                        toast.success(' Updated successfully.', {
                                            position: "top-right",
                                            autoClose: 5000,
                                            hideProgressBar: true,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                        });
                                        this.props.history.push(`/Home/Ship/${shipId}/Tasks`);
                                        dispatch(getOtherTask(parseInt(shipId), 1));
                                        this.setState({ taskType: false, attachments: [], multifilesPDF: [] })
                                    }
                                    dispatch({
                                        type: "OtherTaskUploadSuccess",
                                        data: res.data,
                                    })
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "OtherTaskUploadFailure",
                                        error: "ERROR"
                                    })
                                })
                        }
                        dispatch({
                            type: "AttachmentsUploadSuccess",
                            data: response.data,
                        })
                    })
                    .catch((error) => {
                        dispatch({
                            type: "AttachmentsUploadFailure",
                            error: "ERROR"
                        })
                    });
            }
            else {
                let url = `${API.PutOtherTask}`;
                let data = {
                    shipTaskId: this.state.searchData.shipTaskId,
                    shipId: this.state.searchData.shipId,
                    task: this.state.searchData.taskType,
                    description: this.state.searchData.taskdescription,
                    deadLine: this.state.searchData.taskdeadLine,
                    completedDate: this.state.searchData.completedDate,
                    isCompleted: false,
                    isDeleted: false,
                    attachments: this.state.files,
                    modifiedBy: userkey.email
                }
                axios.put(url, data)
                    .then((response) => {
                        if (response.data) {
                            toast.success(' Updated successfully.', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            this.props.history.push(`/Home/Ship/${shipId}/Tasks`);
                            dispatch(getOtherTask(parseInt(shipId), 1));
                        }
                        dispatch({
                            type: "OtherTaskUploadSuccess",
                            data: response.data,
                        })
                    })
                    .catch((error) => {
                        dispatch({
                            type: "OtherTaskUploadFailure",
                            error: "ERROR"
                        })
                    })
            }
        }
    }

    CancelTask = () => {
        const { match } = this.props;
        const { params } = match;
        const { shipId } = params;
        this.props.history.push(`/Home/Ship/${shipId}/Tasks`);
        this.props.dispatch({ type: "GetOtherTaskList", data: "" });
    }

    render() {
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3">
                    <div className="col-lg-12">
                        <div className="panel-box search-filter-box">
                            <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                        Update Hazardous Material Removal
                                        </h5>
                                </div>
                            </div>
                            <div className="search-filter-box">
                                <div className="row pb-1">
                                    <div className="col-lg-4">
                                        <label className="form-label">Task</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="taskType"
                                            placeholder="Task"
                                            value={this.state.searchData.taskType}
                                            onChange={e => this.handleInputChange(e)}
                                        ></input>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label">Description</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="taskdescription"
                                            placeholder="Description"
                                            value={this.state.searchData.taskdescription}
                                            onChange={e => this.handleInputChange(e)}
                                        ></input>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label">Deadline</label>
                                        <div
                                            className="input-group add-on date datepicker"
                                            data-date-format="yyyy-mm-dd"  >
                                            <input
                                                type="text"
                                                value={this.state.searchData.taskdeadLine ? Moment(new Date(Date.parse(this.state.searchData.taskdeadLine))).format("YYYY-MM-DD") : ''}
                                                className="form-control date-picker"
                                                placeholder="Deadline"
                                                name="POFromDate" ></input>
                                            <DatePicker
                                                onChange={this.handleDeadlineDateChange}
                                                open={this.state.fromDateOpen}
                                                onClickOutside={this.handleBlur}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                popperPlacement="top-end"
                                                className="form-control date-picker w-5 hide-date" />
                                            <div
                                                className="input-group-btn calendar-icon"
                                                onClick={this.openDeadlineDatePicker}
                                            >
                                                <button className="btn btn-default" style={{ height: "100%" }}>
                                                    <i className="fa fa-calendar mt-1"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label" >Attachments : </label><br></br>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Browse File<input type="file" id="files"  style={{ marginRight: 40 }} multiple name="fileName" onChange={this.fileSelectedHandlers} /></span>
                                            </div>
                                            <input type="text" class="form-control" placeholder="No file chosen" value={this.state.searchData.filesPDF} />
                                            {
                                                this.state.searchData.filesPDF ?
                                                    <div class="input-group-append" style={{cursor:"pointer"}}>
                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInputsPDF()}></i>
                                                    </div> : ''
                                            }

                                        </div>
                                    </div>
                                    <div className="col-lg-8 pt-3">
                                        <label></label><br></br>
                                        <div className="search-btn-col mb-1" style={{ textAlign: "end" }}>
                                            <button
                                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                type="submit"
                                                onClick={() => this.SubmitOtherTask()}
                                            >
                                                {" "}Update{" "}
                                            </button>
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button"
                                                onClick={() => this.CancelTask()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        EditTaskList: state.ShipViewReducer.EditTaskList
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffOtherTaskEdit);